import React from 'react';
import useScreenOrientation from './helpers/useScreenOrientation';

import logoLandscape from "../assets/svgs/Logo_Cliente+Proyecto.svg";
import logoPortrait from "../assets/svgs/Logo_Interfaz_Portrait.svg";

import iconBack from "../assets/svgs/Back.svg";
import iconWarranty from "../assets/svgs/Icon_Garantia.svg";
import iconLocation from "../assets/svgs/Icon_Ubicacion.svg";
import iconQuotation from "../assets/svgs/Icon_Quotation.svg";
import iconSoundOff from "../assets/svgs/Icon_SoundOFF.svg";
import iconSoundOn from "../assets/svgs/Icon_SoundON.svg";
import iconMenu from "../assets/svgs/Icon_Menu.svg";

//import PortraitOptions from "../components/PortraitOptions"

declare const window: any;

export default function MenuAppBar({isLogoVisible = true, isPositionAbsolute = false, isBackButtonVisble = false, isBlur, playBGM, setShowPortraitOptions, setView, setPlayBGM}: any) {

  const isLandscape = useScreenOrientation();

  const openInNewTab = (url: string) => {
    window.open(url, "_blank", "noreferrer");
  };

  return (
    <div className={`top-bar-container ${isPositionAbsolute ? 'absolute' : ''} ${isLandscape ? '' : 'portrait'}`}>

      {isLandscape ?
        <div className={`top-bar-desktop ${isBlur ? "blur" : ""}`}>

          { isBackButtonVisble &&
            <div className="top-bar-buttons-container">
              <div className="top-bar-button back" onClick={() => setView("IntroSelection")} >
                <img className={`top-bar-button-icon`} src={iconBack} alt=''/>
                <div className="top-bar-button-text">
                  Volver a Proyectos
                </div>
              </div>
            </div>
          }

          <img className={`top-bar-logo ${isBackButtonVisble ? 'compact' : '' } ${isLogoVisible ? '' : 'invisible' }`} src={logoLandscape} alt='' onClick={() => window.location.reload()}/>

          <div className="top-bar-buttons-container">
            <div className="top-bar-button" onClick={() => window.location.reload()} >
              <div className="top-bar-button-text">
                Inicio
              </div>
            </div>

            <div className="top-bar-button" onClick={() => openInNewTab("https://www.acesco.com.co/contacto/")} >
              <img className={`top-bar-button-icon`} src={iconQuotation} alt=''/>
              <div className="top-bar-button-text">
                Cotiza
              </div>
            </div>

            <div className="top-bar-button" onClick={() => openInNewTab("https://www.acesco.com.co/distribuidores/")} >
              <img className={`top-bar-button-icon`} src={iconLocation} alt=''/>
              <div className="top-bar-button-text small">
                Distribuidores
              </div>
            </div>

            <div className="top-bar-button" onClick={() => openInNewTab("https://www.acesco.com.co/garantia-de-productos/")} >
              <img className={`top-bar-button-icon`} src={iconWarranty} alt=''/>
              <div className="top-bar-button-text">
                Garantía
              </div>
            </div>

            <div className="top-bar-button-sound" onClick={() => setPlayBGM(!playBGM)} >
              <img className={`top-bar-button-icon-sound`} src={playBGM ? iconSoundOff : iconSoundOn} alt=''/>
            </div>
            
          </div>
        </div>
        :
        // PORTRAIT VIEW
        <div className={`top-bar-portrait ${isBlur ? "blur" : ""}`}>
          <img className={`top-bar-logo-portrait ${isLogoVisible ? '' : 'invisible' }`} src={logoPortrait} alt='' onClick={() => window.location.reload()}/>
          <div className={`top-bar-button-container`}>
            <div className={`top-bar-button-portrait`} onClick={() => setShowPortraitOptions(true)} >
              <img className={`top-bar-button-icon-portrait`} src={iconMenu} alt=''/>
              <div className="top-bar-button-text-portrait">
                Opciones
              </div>
            </div>
            <div className="top-bar-button-sound" onClick={() => setPlayBGM(!playBGM)} >
              <img className={`top-bar-button-icon-sound`} src={playBGM ? iconSoundOff : iconSoundOn} alt=''/>
            </div>
          </div>
        </div>
      }
    </div>
  );
};